import { BiLinkExternal } from 'react-icons/bi';
import { buttonVariants, HStack, Text } from 'ui_2';

type Props = {
  url: string;
  className?: string;
};

export const ViewProductDetails = ({ url, className }: Props) => {
  return (
    <a
      href={url}
      target='_blank'
      className={buttonVariants({
        variant: 'gray',
        className: `w-full content-center ${className}`,
      })}
    >
      <HStack className='w-full items-center justify-center gap-2'>
        <Text font='xs'>View product details</Text>
        <BiLinkExternal />
      </HStack>
    </a>
  );
};
